import script from "./DealCarouselCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./DealCarouselCard.vue?vue&type=script&setup=true&lang=ts"

import "./DealCarouselCard.vue?vue&type=style&index=0&id=6deee1d1&lang=scss"

const __exports__ = script;

export default __exports__